import React from 'react';
import Drawer, { DrawerProps } from '@app/component/overlays/drawer/Drawer';
import Utilities from '@util/Utilities';
import PriceRecommendationDrawerContents from './PriceRecommendationDrawerContents';

type Props = Omit<DrawerProps, 'title'> & {
	statDate: string,
}

const MarketStateSnapshotCalendarDayPriceRecommendationDrawer = React.memo(
	function MarketStateSnapshotCalendarDayPriceRecommendationDrawer({ statDate, ...props }: Props) {
		return <Drawer title={`Recommended Rate - ${Utilities.formatDateString(statDate, 'DD MMMM YYYY', false)}`}
		               zIndexClass="z-40" noCloseOnOverlayClick {...props}>
			<div className="mt-2 px-6 py-5 space-y-6">
				<div className="text-sm text-pretty"><p className="text-gray-600">Your recommended rate is calculated by our
					dynamic pricing engine, optimized for higher revenue. This figure intelligently balances current market
					demand, your hotel's projected occupancy, and local competitor pricing strategies.</p></div>
				<PriceRecommendationDrawerContents statDate={statDate} onSubmitPrices={() => props.ref.current?.close()} />
			</div>
		</Drawer>;
	},
);

export default MarketStateSnapshotCalendarDayPriceRecommendationDrawer;